import { Icon } from '@chakra-ui/react';

const CustomDownloadPageOutlineIcon = (props) => (
  <Icon viewBox="0 0 31 31" fill="none" {...props}>
    <path
      d="M15.5001 8.25V18.4M11.1501 14.05L15.5001 18.4L19.8501 14.05"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.3 22.75H9.69995"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M1 15.5C1 8.6647 1 5.24705 3.1228 3.1228C5.2485 1 8.6647 1 15.5 1C22.3353 1 25.753 1 27.8758 3.1228C30 5.2485 30 8.6647 30 15.5C30 22.3353 30 25.753 27.8758 27.8758C25.7544 30 22.3353 30 15.5 30C8.6647 30 5.24705 30 3.1228 27.8758C1 25.7544 1 22.3353 1 15.5Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </Icon>
);

export default CustomDownloadPageOutlineIcon;
